import { prodBaseUrls } from 'src/environments/base-urls';
import {
  environment as baseEnvironment,
  baseUrls,
} from 'src/environments/environment.base';

// Allowing the API base URLs to be overridden via query params is only
// intended for local/dev/staging/test workflows. `environment.base.ts` is
// swapped out per build (see angular.json `fileReplacements`) and both the
// prod and beta configs set `production: true`, so gating on that flag
// disables the override in both of those builds.
const allowUrlOverride = !baseEnvironment.production;
const urlParams = new URLSearchParams(window.location.search);
const coreApiUrl = allowUrlOverride ? urlParams.get('core_api_url') : null;
const storeApiUrl = allowUrlOverride ? urlParams.get('store_api_url') : null;
const storageApiUrl = allowUrlOverride
  ? urlParams.get('storage_api_url')
  : null;

const urlGetters = {
  get CORE_BASE_URL() {
    return coreApiUrl ?? baseUrls.CORE_BASE_URL;
  },
  get STORE_BASE_URL() {
    return storeApiUrl ?? baseUrls.STORE_BASE_URL;
  },
  get STORAGE_BASE_URL() {
    return storageApiUrl ?? baseUrls.STORAGE_BASE_URL;
  },
};

export const environment = {
  ...baseEnvironment,
  BLUEPRINT_URL: baseUrls.TEMPLATES_BASE_URL + '/blueprint.json',
  LAYOUT_METADATA_URL: baseUrls.LAYOUTS_BASE_URL + '/metadata.json',
  STORE_SERVER_URL: urlGetters.STORE_BASE_URL + '/',
  VIEWER_URL: baseUrls.VIEWER_BASE_URL,
  SHARED_SCHEDULE_URL:
    baseUrls.VIEWER_BASE_URL + '/?type=sharedschedule&id=SCHEDULE_ID',
  ALERTS_WS_URL: urlGetters.CORE_BASE_URL + '/alerts/cap',
  SCREEN_SHARING_SERVICE_URL:
    'wss://' + baseUrls.SERVICES2_BASE_DOMAIN + '/screensharing/',
  SCREEN_SHARING_API_URL:
    'https://' + baseUrls.SERVICES2_BASE_DOMAIN + '/screensharing/',
  MESSAGING_PRIMUS_URL:
    baseUrls.SERVICES_BASE_URL + '/messaging/primus?displayId=apps&machineId=1',
  OAUTH_TOKEN_PROVIDER_URL: baseUrls.SERVICES_BASE_URL + '/oauthtokenprovider/',
  TWITTER_SERVICE_URL: baseUrls.SERVICES_BASE_URL + '/twitter/',
  GOOGLE_SERVICE_URL: baseUrls.SERVICES_BASE_URL + '/google/',
  DATA_SERVICE_URL: baseUrls.SERVICES_BASE_URL + '/data/',
  POWERBI_SERVICE_URL: baseUrls.SERVICES_BASE_URL + '/data/ms-pbi/',
  MICROSOFT_OUTLOOK_SERVICE_URL:
    baseUrls.SERVICES_BASE_URL + '/data/ms-graph/calendar/',
  MICROSOFT_ONEDRIVE_SERVICE_URL:
    baseUrls.SERVICES_BASE_URL + '/data/ms-graph/onedrive/',
  HTML_TEMPLATE_URL: baseUrls.TEMPLATES_BASE_URL + '/src/template.html',
  SSO_LOGIN_URL: urlGetters.CORE_BASE_URL + '/sso/login',
  SPRING_ENDPOINT_URL: urlGetters.CORE_BASE_URL + '/api/core',
  SPRING_STORAGE_ENDPOINT_URL: urlGetters.STORAGE_BASE_URL + '/api/storage',
  SPRING_STORE_ENDPOINT_URL: urlGetters.STORE_BASE_URL + '/api/store',
  AI_SERVICE_URL: 'https://' + baseUrls.SERVICES2_BASE_DOMAIN + '/ai-service',
  PROXY_URL: 'https://' + baseUrls.SERVICES2_BASE_DOMAIN + '/proxy/',
  FEED_PARSER_URL: 'https://' + baseUrls.SERVICES2_BASE_DOMAIN + '/feedparser/',
  // Apps insert into client-side-events.Apps_Events, not endpoint-event-logs.
  // The staging token SA has no writer on that dataset; keep the production token host.
  BQ_ENDPOINT_LOGGER_TOKEN_URL:
    'https://' +
    prodBaseUrls.SERVICES2_BASE_DOMAIN +
    '/bq-endpoint-logger-token',
  AI_SERVICE_API_KEY: '#kwXjiteKMo$72',
  CHARGEBEE: 'V2',
};
